/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-29 17:32:46
 * @LastEditTime: 2020-10-29 17:34:16
 */
const monitorTerminal = {
  state: {
    terminalDevice: '', // 设备分组id
  },
  mutations: {
    // 设置deviceGroupId
    SETDEVICE(state, device) {
      state.terminalDevice = device
    },
  },
  actions: {
    setDevice({ commit }, device) {
      commit('SETDEVICE', device)
    }
  }
}
export default monitorTerminal